import type { LearnPracticalContent } from "../practicalContent.js";

export const earthquakeContent: LearnPracticalContent = {
  th: {
    notice: [
      "แรงสั่นอาจทำให้กระจก ของบนชั้น และชิ้นส่วนอาคารตกลงมา",
      "หลังหยุดสั่น อาคารอาจยังเสียหายและเกิดแรงสั่นตามมาได้",
      "ถ้าอยู่ใกล้ชายฝั่ง แรงสั่นที่รุนแรงหรือนานอาจตามด้วยความเสี่ยงสึนามิ",
      "ที่ทำงาน โรงเรียน รถไฟฟ้า และคอนโดมีขั้นตอนของสถานที่ต่างกัน หลังการสั่นให้ฟังประกาศของผู้ดูแลอาคารหรือพนักงาน",
    ],
    prepare: [
      "หาจุดกำบังที่แข็งแรงในห้อง และยึดของหนักที่อาจล้ม",
      "รู้ทางออกและจุดนัดพบของอาคารไว้ล่วงหน้า",
      "ฝึกหมอบ–กำบัง–ยึด และวางรองเท้า ไฟฉาย กับของจำเป็นไว้ในจุดที่หยิบได้",
      "ตกลงวิธีติดต่อและจุดนัดพบกับคนในบ้านเผื่อสัญญาณโทรศัพท์ขัดข้องหรือกลับเข้าที่พักไม่ได้",
    ],
    during: [
      "ถ้าอยู่ในอาคาร ให้หมอบ กำบังใต้โต๊ะที่แข็งแรง และยึดไว้จนหยุดสั่น",
      "อยู่ห่างจากกระจกและของที่อาจตก ถ้าอยู่นอกอาคารให้ห่างจากอาคาร เสา และสายไฟ",
      "ถ้ากำลังขับรถ ให้จอดในจุดที่ปลอดภัย ห่างจากสะพาน ทางยกระดับ และสายไฟ แล้วอยู่ในรถจนหยุดสั่น",
      "ถ้าอยู่บนเตียง ให้อยู่บนเตียงและใช้หมอนป้องกันศีรษะ เว้นแต่มีของหนักอยู่เหนือศีรษะ",
    ],
    avoid: [
      "อย่าวิ่งออกจากอาคารระหว่างที่ยังสั่น",
      "อย่าใช้ลิฟต์ และอย่าเข้าอาคารที่เห็นความเสียหายจนกว่าจะได้รับอนุญาต",
      "อย่ายืนที่วงกบประตูโดยคิดว่าปลอดภัยกว่าจุดอื่น และอย่าอยู่ใกล้หน้าต่าง",
      "อย่าใช้ข่าวหรือคลิปเก่าเป็นหลักตัดสินใจเรื่องอาคารหรือการอพยพ ให้ตรวจประกาศของอาคารและหน่วยงานในพื้นที่",
    ],
    help: [
      "ขอความช่วยเหลือเมื่อมีผู้บาดเจ็บ ไฟไหม้ กลิ่นก๊าซ หรืออาคารเสียหาย",
      "ติดตามประกาศของหน่วยงานในพื้นที่ก่อนเคลื่อนย้ายหรือกลับเข้าอาคาร",
      "หากติดอยู่ ให้ใช้ข้อความหรือเคาะผนัง/ท่อเพื่อบอกตำแหน่ง และป้องกันฝุ่นเข้าปากจมูกเท่าที่ทำได้",
      "ขอความช่วยเหลือเมื่อมีคนที่ต้องใช้ยา อุปกรณ์ช่วยเดิน หรือความช่วยเหลือในการออกจากอาคาร และแจ้งความต้องการนั้นให้ชัดเจน",
    ],
    example:
      "กำลังอยู่ในห้องที่มีตู้สูงแล้วพื้นเริ่มสั่น: หมอบและกำบังกับโต๊ะที่แข็งแรงแทนการวิ่งผ่านของที่อาจล้ม เมื่อหยุดสั่นจึงดูความเสียหายและทำตามคำสั่งอาคาร",
    situations: [
      {
        title: "คอนโด",
        text: "วางรองเท้าและไฟฉายใกล้ที่นอน รู้บันไดหนีไฟและจุดรวมพลของอาคาร แต่ไม่ใช้ลิฟต์หลังการสั่นจนผู้ดูแลอาคารแจ้งว่าปลอดภัย",
      },
      {
        title: "ที่ทำงาน",
        text: "ระหว่างประชุม ให้หมอบ กำบัง และยึดก่อน ไม่วิ่งออกพร้อมกันระหว่างที่ยังสั่น แล้วทำตามผู้ประสานงานอาคาร",
      },
      {
        title: "ระหว่างเดินทาง",
        text: "ถ้าอยู่บนรถ ให้จอดห่างจากสะพาน สายไฟ และสิ่งก่อสร้างเมื่อทำได้อย่างปลอดภัย แล้วรอจนหยุดสั่นก่อนเดินทางต่อ",
      },
    ],
    checklist: [
      "รู้จุดกำบังในห้อง",
      "ยึดของหนักที่อาจล้ม",
      "ฝึกหมอบ–กำบัง–ยึด",
      "รู้ทางออกและจุดนัดพบ",
      "ตรวจอันตรายก่อนกลับเข้าอาคาร",
      "เตรียมรองเท้าและไฟฉายใกล้ที่นอน",
      "ตกลงการติดต่อเมื่อเครือข่ายขัดข้อง",
    ],
  },
  en: {
    notice: [
      "Shaking can bring down glass, shelf contents, and parts of a building.",
      "After shaking stops, damaged buildings and aftershocks may remain hazardous.",
      "Near the coast, strong or long shaking may be followed by a tsunami hazard.",
      "Workplaces, schools, rail systems, and apartments have venue-specific procedures; after shaking, listen to staff or building-management instructions.",
    ],
    prepare: [
      "Identify a sturdy shelter point in each room and secure heavy items that could fall.",
      "Know the building exits and your household meeting point.",
      "Practise Drop, Cover, and Hold On, and keep shoes, a torch, and essentials accessible.",
      "Agree on a contact method and meeting point in case mobile service fails or you cannot return home.",
    ],
    during: [
      "Indoors, drop, take cover under sturdy furniture, and hold on until shaking stops.",
      "Stay away from glass and falling objects; outdoors, move clear of buildings, poles, and wires.",
      "If driving, stop in a safe place away from bridges, overpasses, and wires, and remain in the vehicle until shaking stops.",
      "If in bed, stay there and protect your head with a pillow unless heavy objects are directly above you.",
    ],
    avoid: [
      "Do not run outside while the ground is still shaking.",
      "Do not use lifts or re-enter visibly damaged buildings until authorities permit it.",
      "Do not stand in a doorway expecting extra protection, and keep away from windows.",
      "Do not base building or evacuation decisions on old clips or unverified posts; check venue and local authority information.",
    ],
    help: [
      "Seek help for injuries, fire, a gas smell, or building damage.",
      "Follow local authority information before moving or returning to a building.",
      "If trapped, use a message or tap on a wall or pipe to signal your location and protect your mouth and nose from dust when possible.",
      "Request assistance for someone who needs medicines, mobility equipment, or help leaving the building, and state that need clearly.",
    ],
    example:
      "You are beside tall shelving when shaking starts: drop and take cover at sturdy furniture instead of running past falling objects. Once shaking stops, assess damage and follow building instructions.",
    situations: [
      {
        title: "Apartment",
        text: "Keep shoes and a torch near the bed, know the fire stairs and building meeting point, and do not use a lift after shaking until building staff say it is safe.",
      },
      {
        title: "Workplace",
        text: "During a meeting, drop, cover, and hold on first rather than running out together while shaking continues; then follow the building coordinator.",
      },
      {
        title: "Travel",
        text: "If driving, stop away from bridges, wires, and structures when it is safe, then wait until shaking stops before continuing.",
      },
    ],
    checklist: [
      "Know a cover point",
      "Secure heavy items",
      "Practise Drop, Cover, and Hold On",
      "Know exits and a meeting point",
      "Check hazards before re-entering",
      "Keep shoes and a torch by the bed",
      "Agree how to communicate if networks fail",
    ],
  },
};
